import React, { useMemo } from 'react';
import { makeCookedProduct } from '@apps/registry/common/selectors/ProductListSelector';
import { RegistryItemFragment } from '@graphql/generated';
import { useCurrencyFormatter } from '@shared/utils/currency';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem, styled } from '@withjoy/joykit/theme';

interface RegistryItemDisplayDetailsProps {
  item: RegistryItemFragment;
}

const ProductTitle = styled(TextV2)`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ProductPhoto = ({ photoUrl }: { photoUrl: string }) => {
  return (
    <Box size={pxToRem(110)} flexShrink={0}>
      <Box width="100%" paddingTop="100%" backgroundSize="contain" backgroundRepeat="no-repeat" style={{ backgroundImage: `url('${photoUrl}')` }} />
    </Box>
  );
};

export const RegistryItemDisplayDetails = (props: RegistryItemDisplayDetailsProps) => {
  const { item } = props;

  const { formatCurrency } = useCurrencyFormatter();
  const productData = item.productData;
  const photo = productData.photos[0];
  const { brand, title } = productData;

  const formatted = useMemo(() => {
    return makeCookedProduct({ formatCurrency, item });
  }, [formatCurrency, item]);

  const { cookedProduct, priceRelatedItems } = formatted;
  const salePrice = formatCurrency({
    priceFloatingPointDecimalString: cookedProduct?.salePrice || '',
    priceCurrencyCode: cookedProduct?.salePriceCurrencyCode,
    formatForm: 'short',
    shouldCalculateCharmPrice: true
  });
  return (
    <Flex columnGap={5}>
      {photo && <ProductPhoto photoUrl={photo.url} />}
      <Flex flexDirection={'column'} rowGap={1} flexGrow={1}>
        {brand && (
          <TextV2 typographyVariant="label2" color="mono10">
            {brand}
          </TextV2>
        )}
        <ProductTitle typographyVariant="body1" fontWeight="semibold">
          {title}
        </ProductTitle>
        {priceRelatedItems?.price && (
          <Flex gap="2">
            <TextV2 typographyVariant="hed1" color="#2B2B2B" textDecoration={(cookedProduct?.salePrice !== priceRelatedItems.price && 'line-through') || ''}>
              {priceRelatedItems.price}
            </TextV2>
            {salePrice && salePrice !== priceRelatedItems.price && (
              <TextV2 as="span" color="#D80B0B" typographyVariant="hed1" alignContent="center">
                {salePrice}
              </TextV2>
            )}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
